
  <header role="banner" *ngIf="tenantService.isCXOne===false" [attr.aria-label]="'banner.landmark.label' | translate">
  <nav class="top-bar navbar navbar-expand-lg navbar-dark fixed-top" [ngClass]="showMainLayoutCssObj">
    <span class="app-name">Enhanced Strategic Planner</span>
    <button class="navbar-toggler"
            type="button"
            aria-controls="navbarSupportedContent"
            [attr.aria-expanded]="!isTopNavCollapsed"
            [attr.aria-label]="'Toggle navigation'"
            (click)="toggleTopNav()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isTopNavCollapsed">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown dropdown-user" ngbDropdown #myDrop="ngbDropdown">
          <button type="button" class="nav-link dropdown-toggle" id="navbarDropdown" tabindex="0" ngbDropdownToggle>
            <span>{{username}}</span>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarDropdown">
            <button *ngIf="showApiCredentialsMenuItem()"
               type="button"
               id="apiCredsLink"
               ngbDropdownItem
               [disabled]="!isPublicApiFeatureEnabled()"
               (click)="showApiCredentialsDialog()"
               title="{{'api.credentials.dropdown.item' | translate}}">
              {{"api.credentials.dropdown.item" | translate}}
            </button>
            <button type="button" id="logoutLink" ngbDropdownItem (click)="logout()">
              {{"logout" | translate}}
            </button>
          </div>
        </li>
      </ul>
      <div class = "help-icon">
          <button id="helpLink" type="button" class="btn-icon"
            [attr.aria-label]="'esp.help.aria.label' | translate"
            title="{{'esp.help' | translate}}"
            (click)="gotoHelp()">
            <i class="icon icon-help"></i>
          </button>
      </div>
      <div class="navbar-brand">
          <img src="/assets/images/nice-logo-white.svg" height="24" alt="NICE Ltd">
      </div>
    </div>
  </nav>
  </header>
  <div class="d-flex flex-column flex-nowrap content-wrapper app-wrapper"
       [ngClass]="{'with-top-bar': showMainLayout && !this.tenantService.isCXOne,'show-mini-sidebar':!isMenuExpanded}">
    <div class="app-content d-flex flex-row flex-nowrap flex-grow-1 flex-shrink-1" style="flex-basis: 100%">
      <app-side-nav *ngIf="tenantService.isCXOne===false"
                    [ngClass]="showMainLayoutCssObj"
                    [tabIndex]="0"
                    [inputMenuItems]="menu"
                    [isMenuExpanded]="isMenuExpanded"
                    (onMenuItemClick)="handleMenuItemClickEvent($event)"
                    (SidebarToggle)="onSidebarToggle()">
      </app-side-nav>
      <!--<div class="sidebar flex-grow-0 flex-shrink-0 flex-column flex-nowrap" [ngClass]="showMainLayoutCssObj" #sidebar>
        <div class="d-flex flex-row flex-nowrap wfm-main-sidebar justify-content-end"
             style="background-color: #F2F5F7;flex-basis: 18px">
            <button type="button" class="flex-grow-0 flex-shrink-0" id="main-sidebar-toggle-1"
                    (click)="showMiniSidebar = !showMiniSidebar; updateShowMainLayout()"
                    style="padding: 0; height: 18px; border: none; background-color: transparent; cursor: pointer">
              <svg *ngIf="showMiniSidebar" style="width: 18px;height: 16px; transform: rotate(90deg)">
                <use xlink:href="#icon-open" />
              </svg>
              <svg *ngIf="!showMiniSidebar" style="width: 16px;height: 16px; transform: rotate(-90deg); margin-top: -11px">
                <use xlink:href="#icon-close" />
              </svg>
            </button>
        </div>
        <div class="wfm-sidebar-menu-container">
          <ul class="nav flex-column main-menu nav-pills">
            <li class="nav-item">
              <a routerLink="/plans" routerLinkActive="active">
                <svg style="width: 20px;height: 20px"><use xlink:href="#icon-task" /></svg>
                <span class="item-label">{{'plan.page.title' | translate}}</span>
                <span class="fa"></span>
              </a>
            </li>
          </ul>
          <ul class="nav flex-column main-menu nav-pills">
            <li class="nav-item">
              <a routerLink="/imported-forecasts" routerLinkActive="active">
                <svg style="width: 20px;height: 20px"><use xlink:href="#icon-task" /></svg>
                <span class="item-label">{{'imported.forecasts.page.title' | translate}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>-->
      <div class="main-content flex-grow-1 flex-shrink-1 d-flex flex-column flex-nowrap" style="flex-basis: 100%"
           role="main" [attr.aria-label]="'main.landmark.label' | translate"
           [ngClass]="{'container-fluid': showMainLayout}">
        <p *ngIf="isError" class="message-unstyled text-white"
           style="background-color: rgba(190, 31, 31, 0.9); margin-bottom: 0; padding-bottom: 13px; z-index: 10; position: absolute; width: 100%; opacity: 1">
          <svg style="width: 16px;height: 16px" fill="white"><use xlink:href="#icon-system-error" /></svg>
          There was a problem connecting to Enhanced Strategic Planner.
        </p>
        <div class="content-area flex-shrink-1 flex-grow-1" style="flex-basis: 100%; position: relative; overflow-y: auto; overflow-x: hidden">
            <router-outlet></router-outlet>

        </div>
      </div>
    </div>
  </div>
<svg width="10" height="10">
  <symbol id="icon-open" viewBox="5 0 20 20">
    <title>open</title>
    <path d="M9.3 9c0.2-0.2 0.4-0.2 0.6-0.2s0.4 0 0.6 0.2l5.4 5.1c0.2 0.2 0.2 0.6 0 0.9-0.2 0.2-0.6 0.2-0.9 0l-5.1-4.8-4.8 4.8c-0.2 0.2-0.6 0.2-0.9 0-0.2-0.2-0.2-0.6 0-0.9l5.1-5.1z"></path>
    <path d="M14.9 11l-5.1-4.8-4.7 4.8c-0.2 0.2-0.6 0.2-0.9 0-0.2-0.2-0.2-0.6 0-0.9l5.1-5.1c0.2-0.2 0.4-0.2 0.6-0.2s0.4 0 0.6 0.2l5.4 5.1c0.2 0.2 0.2 0.6 0 0.9-0.3 0.2-0.7 0.2-1 0z"></path>
  </symbol>
  <symbol id="icon-close" viewBox="1 0 20 20">
    <title>open</title>
    <path d="M9.3 9c0.2-0.2 0.4-0.2 0.6-0.2s0.4 0 0.6 0.2l5.4 5.1c0.2 0.2 0.2 0.6 0 0.9-0.2 0.2-0.6 0.2-0.9 0l-5.1-4.8-4.8 4.8c-0.2 0.2-0.6 0.2-0.9 0-0.2-0.2-0.2-0.6 0-0.9l5.1-5.1z"></path>
    <path d="M14.9 11l-5.1-4.8-4.7 4.8c-0.2 0.2-0.6 0.2-0.9 0-0.2-0.2-0.2-0.6 0-0.9l5.1-5.1c0.2-0.2 0.4-0.2 0.6-0.2s0.4 0 0.6 0.2l5.4 5.1c0.2 0.2 0.2 0.6 0 0.9-0.3 0.2-0.7 0.2-1 0z"></path>
  </symbol>
  <symbol id="icon-task" viewBox="0 0 20 20">
    <title>Task</title>
    <path d="M0 6h4v-4h-4v4zM0 12h4v-4h-4v4zM0 18h4v-4h-4v4zM6 3v2h14v-2h-14zM6 11h14v-2h-14v2zM6 17h14v-2h-14v2z"></path>
  </symbol>
  <symbol id="icon-system-error" viewBox="0 0 20 20">
    <title>system_error</title>
    <path d="M10 0c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zM11 14.5c0 0.6-0.4 1-1 1s-1-0.4-1-1v-1c0-0.6 0.4-1 1-1s1 0.4 1 1v1zM11 9.5c0 0.6-0.4 1-1 1s-1-0.4-1-1v-4c0-0.6 0.4-1 1-1s1 0.4 1 1v4z"></path>
  </symbol>
</svg>
<p-toast position="bottom-right" class="p-toast-esp-root">

</p-toast>
<!-- icon font loader -->
<div class="d-none" >
  <i class="icon-file"></i>
</div>
